(() => {
  const copiedLabel = "Link copied";

  function announce(button, message) {
    const toast = button.parentElement?.querySelector("[data-stz-product-share-toast]");
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    window.setTimeout(() => {
      toast.hidden = true;
      toast.textContent = "";
    }, 2200);
  }

  async function copyUrl(url) {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      return;
    }

    const input = document.createElement("textarea");
    input.value = url;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.opacity = "0";
    document.body.append(input);
    input.select();
    const copied = document.execCommand("copy");
    input.remove();
    if (!copied) throw new Error("Clipboard copy was unavailable");
  }

  async function copyAndAnnounce(button, url) {
    try {
      await copyUrl(url);
      announce(button, copiedLabel);
    } catch {
      announce(button, "Unable to copy link");
    }
  }

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-stz-product-share]");
    if (!(button instanceof HTMLButtonElement)) return;

    const title = button.dataset.shareTitle || document.title;
    const text = button.dataset.shareText || title;
    const url = window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
      } catch (error) {
        if (error?.name !== "AbortError") await copyAndAnnounce(button, url);
      }
      return;
    }

    await copyAndAnnounce(button, url);
  });
})();
